import previewImage from "@/modules/communication/private/PreviewImage";
import cameraStationPreview from "@/modules/communication/private/CameraStationPreview";
import { commEmitter } from "@/modules/events/emitter";
import PresenceKeeper from "@/modules/app/Presence";
import { getCameraDevices } from "@/store/devices/selectors";
import { useDevices } from "@/store/devices";
import { getCameraStationPreview } from "viewer/modules/cloud/station";
import { viewerStore } from "viewer/store/viewer";

const { setCameraPreview, removeCameraPreview } = viewerStore();

export default class PreviewManager {
  static getOfflinePreviews = async () => {
    const cameras = getCameraDevices(useDevices.getState());

    await Promise.allSettled(
      cameras
        .filter((c) => PresenceKeeper.get(c.jid) === "unavailable")
        .map(async (camera) => {
          try {
            log.info("About to get preview for", camera.jid);
            const encodedCameraStatus = await getCameraStationPreview(camera.jid);
            const cameraStatus = this.decodeCameraPreviewStatus(encodedCameraStatus);

            log.info("camera is unavailable, setting only the preview image", camera.jid);
            setCameraPreview(camera.jid, { image: cameraStatus.image });
          } catch (err) {
            log.err(err);
          }
        })
    );
  };

  private static decodeCameraPreviewStatus = (message: EncodedPreviewStatus) => {
    const image = previewImage.decode(message.image);
    return { image };
  };

  static startListeningForUpdates = () => {
    commEmitter.on("presence-payload", this.handleCurrentStatePayload);
    useDevices.subscribe(this.handleStoreUpdate);
  };

  private static handleCurrentStatePayload = (payload: Partial<CameraCurrentStatePayload>, from: string) => {
    try {
      log.media("Received encoded preview message", from);
      const { currentState: encodedCurrentState } = payload;
      if (!encodedCurrentState) return;

      const currentState = cameraStationPreview.decode(encodedCurrentState);
      setCameraPreview(from, currentState);
    } catch (err) {
      log.err("Error decoding currentState payload");
      log.err(err);
    }
  };

  private static handleStoreUpdate = async (state: DevicesStore, prevState: DevicesStore) => {
    log.media("Comparing device list...");
    const cameras = getCameraDevices(state);
    const previousCameras = getCameraDevices(prevState);

    if (cameras.length < previousCameras.length) {
      const oldCamera = previousCameras.find((camera) => !cameras.find((c) => c.jid === camera.jid));
      if (oldCamera) {
        log.media("Old camera found, removing preview for", oldCamera.jid);
        removeCameraPreview(oldCamera.jid);
      }
    }
  };
}
